import vuetifyDefaultLang from 'vuetify/lib/locale/en.mjs';

export default {
  $vuetify: {
    ...vuetifyDefaultLang,
  },
};
